import { useState, useEffect } from "react";
import { Wifi, WifiOff } from "lucide-react";
import { subscribeToConnectionState, isBannerVisible } from "@/lib/server-status";

export function ReconnectingBanner() {
  const [visible, setVisible] = useState(isBannerVisible());
  const [fadingOut, setFadingOut] = useState(false);
  const [isBack, setIsBack] = useState(false);

  useEffect(() => {
    const unsub = subscribeToConnectionState((state) => {
      if (state === "reconnecting") {
        setFadingOut(false);
        setIsBack(false);
        setVisible(true);
      } else if (state === "online") {
        setIsBack(true);
        setFadingOut(false);
        let innerTimer: NodeJS.Timeout;
        const t = setTimeout(() => {
          setFadingOut(true);
          innerTimer = setTimeout(() => {
            setVisible(false);
            setIsBack(false);
            setFadingOut(false);
          }, 600);
        }, 1200);
        return () => {
          clearTimeout(t);
          if (innerTimer) clearTimeout(innerTimer);
        };
      }
    });
    return unsub;
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="banner-reconnecting"
      role="status"
      aria-live="polite"
      className={`
        fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-2
        px-4 py-2 text-xs font-mono font-medium
        transition-all duration-500 ease-in-out
        ${fadingOut ? "opacity-0 -translate-y-2" : "opacity-100 translate-y-0"}
        ${isBack
          ? "bg-emerald-900/90 text-emerald-300 border-b border-emerald-700/50"
          : "bg-yellow-900/90 text-yellow-300 border-b border-yellow-700/50"
        }
      `}
    >
      {isBack ? (
        <>
          <Wifi className="w-3 h-3" />
          <span>Connection restored</span>
        </>
      ) : (
        <>
          <WifiOff className="w-3 h-3 animate-pulse" />
          <span>Reconnecting to server…</span>
        </>
      )}
    </div>
  );
}
